module.exports = __webpack_public_path__ + "static/media/チュロサコユウヤ.a321e129.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/store/チュロサコユウヤ.png
// module id = 337
// module chunks = 10